<template>

    <section v-if="visible" class="">
        <slot></slot>
    </section>

</template>

<style lang="scss">
    .crud main section {
        @include clearfix();
        .item-image {
            max-height: 230px;
            border-radius: $standardBorderRadius;
            margin-bottom: 1em;
            display: block;
            max-width: 80%;
            @include mobile() {
                margin: 0 auto 1em auto;
            }
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                visible: false
            }
        },
        watch: {},
        computed: {
            name() {
                return this.$parent.name;
            }
        },
        methods: {},
        mounted() {
            var that = this;

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.visible = true;
            });

            window.eventBus.$on('crud-hide-view-' + this.name, function (item) {
                that.visible = false;
            });

        }
    }
</script>   
